export default "__VITE_ASSET__8d833916__"